export const MEMBERSHIP_PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    price: 0,
    capabilities: [
      'Unlimited focus sessions',
      'Five Beyond the Garden artworks',
      'Tasks and planning',
      'Habits and journal',
      'Saved paintings',
      'Standard export and backups',
    ],
  },
  plus: {
    id: 'plus',
    name: 'Studio Plus',
    prices: {
      monthly: {
        amount: 7,
        label: '$7/month',
        cadence: 'month',
      },
      annual: {
        amount: 49,
        label: '$49/year',
        cadence: 'year',
        equivalent: '$4.08/month',
        savings: 'Save 42% compared with 12 monthly payments',
      },
    },
    capabilities: [
      'Everything in Free',
      'Artwork collections',
      'High-resolution export',
    ],
  },
};

export const SCENE_CATALOG = [
  {
    id: 'threshold-of-autumn',
    name: 'Threshold of Autumn',
    tier: 'free',
    type: 'image',
    collection: 'Beyond the Garden',
    source: 'https://cdn.midjourney.com/ee461b6c-3238-4801-a4ec-596132f86e68/0_2.png',
    width: 2048,
    height: 2048,
    alt: 'Figure amid red trees facing a monumental rectangular sky portal.',
  },
  {
    id: 'the-still-path',
    name: 'The Still Path',
    tier: 'free',
    type: 'image',
    collection: 'Beyond the Garden',
    source: 'https://cdn.midjourney.com/7198c06a-0d0a-486e-8bf8-649177114630/0_3.png',
    width: 1024,
    height: 1024,
    alt: 'Cypress avenue leading toward a sunlit doorway.',
  },
  {
    id: 'a-quiet-arrival',
    name: 'A Quiet Arrival',
    tier: 'free',
    type: 'image',
    collection: 'Beyond the Garden',
    source: 'https://cdn.midjourney.com/2d6a0c36-6b33-454d-88ad-699f5e3139d8/0_1.png',
    width: 2048,
    height: 2048,
    alt: 'Garden visitor standing beneath a floating saucer.',
  },
  {
    id: 'moonlit-sanctuary',
    name: 'Moonlit Sanctuary',
    tier: 'free',
    type: 'image',
    collection: 'Beyond the Garden',
    source: 'https://cdn.midjourney.com/2d6a0c36-6b33-454d-88ad-699f5e3139d8/0_3.png',
    width: 2048,
    height: 2048,
    alt: 'Oversized moon above an intimate garden table.',
  },
  {
    id: 'the-rose-portal',
    name: 'The Rose Portal',
    tier: 'free',
    type: 'image',
    collection: 'Beyond the Garden',
    source: 'https://cdn.midjourney.com/e43c8904-65b0-4011-b0b9-8f7c7ff769ce/0_1.png',
    width: 1024,
    height: 1024,
    alt: 'Seated figure beside a glowing circular coral portal.',
  },
];

export const ARCHIVED_SCENE_CATALOG = [
  { id: 'dawn', name: 'Dawn Garden', tier: 'free', type: 'procedural', collection: 'Original scenes' },
  { id: 'coast', name: 'Quiet Coast', tier: 'free', type: 'procedural', collection: 'Original scenes' },
  { id: 'meadow', name: 'Moonlit Meadow', tier: 'free', type: 'procedural', collection: 'Original scenes' },
  { id: 'golden-hour', name: 'Golden Hour', tier: 'plus', type: 'procedural', collection: 'Original scenes' },
  { id: 'alpine-lake', name: 'Alpine Lake', tier: 'plus', type: 'procedural', collection: 'Original scenes' },
  { id: 'sakura-garden', name: 'Sakura Garden', tier: 'plus', type: 'procedural', collection: 'Original scenes' },
];

export const getScene = (sceneId) =>
  SCENE_CATALOG.find((scene) => scene.id === sceneId)
  || ARCHIVED_SCENE_CATALOG.find((scene) => scene.id === sceneId)
  || null;

export const isVisibleGalleryArtwork = (art) =>
  Boolean(art && SCENE_CATALOG.some((scene) => scene.id === art.scene));

export const getPlan = (planId) =>
  MEMBERSHIP_PLANS[planId] || MEMBERSHIP_PLANS.free;

export const getPlanCapabilities = (planId) => [
  ...getPlan(planId).capabilities,
];

export const canUseScene = (planId, sceneId) => {
  const scene = SCENE_CATALOG.find((item) => item.id === sceneId);
  return Boolean(scene && (scene.tier === 'free' || planId === 'plus'));
};

export const hasCapability = (planId, capability) =>
  getPlanCapabilities(planId).includes(capability);